"use client";
import React, { createRef, RefObject } from "react";
import { NSBoxBaseLayout, NSBoxBaseLayoutProps } from "./NSBoxBaseLayout";
import { NSColumn } from "./NSColumn";

export interface NSBoxBaseLayoutRecursiveProps extends NSBoxBaseLayoutProps
{
	depth: number;
}

export class NSBoxBaseLayoutRecursive extends React.Component<NSBoxBaseLayoutRecursiveProps>
{
	static checkGetValue<T>(box: { NSBoxBaseLayoutRecursive_Main: RefObject<NSBoxBaseLayoutRecursive>, getError: () => string | null }, checkError: boolean, handler: () => T | null): T | null
	{
		if (box.NSBoxBaseLayoutRecursive_Main.current?.NSBoxBaseLayout_Main.current)
			return NSBoxBaseLayout.checkGetValue({
				NSBoxBaseLayout_Main: box.NSBoxBaseLayoutRecursive_Main.current?.NSBoxBaseLayout_Main,
				getError: box.getError,
			}, checkError, handler);
		return null;
	}
	NSBoxBaseLayout_Main = createRef<NSBoxBaseLayout>();
	override render()
	{
		let white = "#ffffff";
		let yellow = "#ffffdd";
		// let pink = "#ffddff";
		// let red = "#ffdddd";
		let cyan = "#ddffff";
		let green = "#ddffdd";
		let gray = "#dddddd";
		//let magenta = "#ddddff";
		let colors = [white, green, yellow, cyan, gray];
		return (
			<NSBoxBaseLayout
				ref={this.NSBoxBaseLayout_Main}
				{...this.props}
			>
				<NSColumn
					style={{
						borderTop: "1px solid black",
						borderLeft: "1px solid black",
						borderRadius: "8px",
						paddingLeft: "14px",
						paddingBottom: "8px",
						paddingRight: "1px",
						backgroundColor: colors[this.props.depth % colors.length]
					}}
				>
					{this.props.children}
				</NSColumn>
			</NSBoxBaseLayout>
		);
	}
}